import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { WebphoneService, WebphoneQuery } from '@etop/state/shop/webphone';
import { Observable } from 'rxjs';
import { PageBaseComponent } from '@etop/web';
import { ConfigService } from '@etop/core';

@Component({
  selector: 'etelecom-cs-incoming-call',
  templateUrl: './incoming-call.component.html',
  styleUrls: ['./incoming-call.component.scss']
})
export class IncomingCallComponent extends PageBaseComponent implements OnInit, OnDestroy {
  @Output() playAudioUrl = new EventEmitter<string>();
  callingPhoneNumber$: Observable<string>;
  callingPhoneName$: Observable<string>;
  isVideoCall$: Observable<boolean>;
  isMuted = false;
  crm_url: string;

  constructor(
    private webphoneService: WebphoneService,
    private webphoneQuery: WebphoneQuery,
    private config: ConfigService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.callingPhoneNumber$ = this.webphoneQuery.select(state => state.callingPhoneNumber);
    this.callingPhoneName$ = this.webphoneQuery.select(state => state.callingPhoneName);
    this.isVideoCall$ = this.webphoneQuery.select(state => state.isVideoCall);
    this.crm_url = this.config.get('crm_url');
  }

  async answerCall(): Promise<void> {
    try {
      await this.webphoneService.answer();
    } catch (error) {
      toastr.error(error.message || 'Không thể trả lời cuộc gọi');
    }
  }

  async rejectCall(): Promise<void> {
    try {
      await this.webphoneService.reject();
    } catch (error) {
      toastr.error(error.message || 'Không thể từ chối cuộc gọi');
    }
  }

  toggleMute(): void {
    try {
      if (this.isMuted) {
        this.playAudioUrl.emit(
          "https://etelecom.s3south.storage.com.vn/ringtones/ringtone.mp3"
        );
      } else {
        this.playAudioUrl.emit(null);
      }
      this.isMuted = !this.isMuted;
    } catch (e) {
      console.error("ERROR in decline", e);
    }
  }

  openTicket() {
    const ticketUrl = this.crm_url + encodeURIComponent(
      this.webphoneQuery.getValue().callingPhoneNumber
    )
    window.open(ticketUrl, "_blank");
  }
}

